export default "__VITE_ASSET__CvUNAzxk__"